import { combineReducers } from "redux";
import { reducerWithInitialState } from "typescript-fsa-reducers";

import { EntitiesMap } from "../../entities";
import { followCompany, unfollowCompany } from "../actions";

import {
  bootstrapCompanyShow,
  bootstrapCompanyAbout,
  bootstrapCompanyMembers,
  bootstrapCompanyPosts,
  bootstrapCompanyProjects,
} from "../../companies/actions";

export interface CompanyFollowingsMainState {
  [key: string]: boolean;
}

export interface CompanyFollowingsState {
  followings: CompanyFollowingsMainState;
  entities: EntitiesMap; // Not using entities yet
}

const companyFollowingsReducer = reducerWithInitialState<CompanyFollowingsMainState>({})
  .cases(
    [
      bootstrapCompanyShow,
      bootstrapCompanyAbout,
      bootstrapCompanyMembers,
      bootstrapCompanyPosts,
      bootstrapCompanyProjects,
    ],
    (state, { entities }) => {
      const { company_followings } = entities;
      const followings = Object.values(company_followings).reduce(
        (obj, v) => {
          if (v) {
            obj[v.company_id] = true;
          }
          return obj;
        },
        {} as CompanyFollowingsMainState
      );
      return { ...state, ...followings };
    }
  )
  .case(followCompany.started, (state, companyId) => {
    return { ...state, [companyId]: true };
  })
  .case(followCompany.failed, (state, { params }) => {
    return { ...state, [params]: false };
  })
  .case(unfollowCompany.started, (state, companyId) => {
    return { ...state, [companyId]: false };
  })
  .case(unfollowCompany.failed, (state, { params }) => {
    return { ...state, [params]: true };
  });

export default combineReducers({
  followings: companyFollowingsReducer,
});



// WEBPACK FOOTER //
// ./frontend/src/company_followings/reducers/index.ts